(function(w, $) {

    var anonymizationNotyOptions = {
        timeout: 3000
    };

    $(function() {
        const formId = 5006;

        const selectors = {
            REQUEST_TRIGGER: '.js-anonymization-prompt',
            PROMPT_DIALOG: '#anonymization-prompt-dialog',
            DENIED_DIALOG: '#anonymization-denied-dialog',

            PROMPT_DANGER: '#anonymization-prompt-danger',
            PROMPT_WARNING: '#anonymization-prompt-warning',
            PROMPT_TEXT: '#anonymization-prompt-text',
            PROMPT_TEXT_ADDITIONAL: '#anonymization-prompt-text-additional',
            DENIED_TEXT: '#anonymization-denied-text',

            CONFIRM_BUTTON: '#anonymization-confirm'
        };

        $.get('/api/metadata/text/' + formId + '/' + w.LanguageID,
            function(texts) {
                const anonymizationTexts = texts;
                // NOTE: Dialog can be reused by some another functionality, and therefore inputs might be cleared, so we have store the texts and reuse them

                const showError = function() {
                    window.noty($.extend({
                            type: 'error',
                            text: anonymizationTexts['anonymizationRequestErrorMessage']
                        },
                        anonymizationNotyOptions));
                };

                // Attach dialog opening on trigger
                $(selectors.REQUEST_TRIGGER).click(function() {
                    const $this = $(this);

                    $.get('/api/user/anonymization/isallowed',
                        function(result) {

                            if (result.isAllowed === true) {
                                // Use retrieved localized texts to substitute hardcoded values
                                $(selectors.PROMPT_DANGER).text(anonymizationTexts['anonymizationPromptDanger']);

                                $(selectors.PROMPT_WARNING).html(
                                    $this.data('account-type') == 'company' && result.hasContacts
                                    ? '<span>' + anonymizationTexts['anonymizationPromptTextCompany'] + '</span> '
                                    : ''
                                );
                                $(selectors.PROMPT_WARNING).append(anonymizationTexts['anonymizationPromptWarning']);

                                $(selectors.PROMPT_TEXT).html(anonymizationTexts['anonymizationPromptText']);

                                const buttons = [
                                    {
                                        text: anonymizationTexts['anonymizationPromptDialogCancelButton'],
                                        'class': 'btn btn-default btn-lg',
                                        click: function() {
                                            $(this).dialog('close');
                                        }
                                    },
                                    {
                                        text: anonymizationTexts['anonymizationConfirmButtonText'],
                                        'id': selectors.CONFIRM_BUTTON.substring(1),
                                        'class': 'btn btn-danger btn-lg',
                                        click: function(event) {
                                            // Disable button to avoid sending multiple requests
                                            $(event.target).attr('disabled', 'disabled');
                                            $.post('/api/user/anonymization/request',
                                                {},
                                                function() {
                                                    $(".ui-dialog-content").dialog("close");
                                                    window.noty($.extend({
                                                            type: 'success',
                                                            text: anonymizationTexts['anonymizationRequestSuccessMessage']
                                                        },
                                                        anonymizationNotyOptions));
                                                }).fail(function() {
                                                // Re-enable button
                                                $(event.target).removeAttr('disabled');
                                                showError();
                                            });
                                        }
                                    }
                                ];

                                $(selectors.PROMPT_DIALOG).dialog({
                                    title: anonymizationTexts['anonymizationPromptDialogTitle'],
                                    resizable: true,
                                    modal: true,
                                    autoOpen: true,
                                    width: 700,
                                    buttons: buttons,
                                    close: function() {
                                        $(selectors.CONFIRM_BUTTON.substring(1)).removeAttr('disabled');
                                        $(selectors.CONFIRM_BUTTON.substring(1)).off('click');
                                    },
                                });
                            } else {
                                $(selectors.DENIED_TEXT).html(anonymizationTexts['thereAreOrdersForLast5Years']);
                                $(selectors.DENIED_DIALOG).dialog({
                                    title: anonymizationTexts['anonymizationNotAllowed'],
                                    resizable: true,
                                    modal: true,
                                    autoOpen: true,
                                    width: 700
                                });
                            }
                        }).fail(showError);
                });
            }
        );
    });
})(window, jQuery);